import electron, { isElectron } from './electron';

const SecretKey = {
  client: 'client', // 客户端日志
  mainProgress: 'mainProgress', // 客户端日志
  protal: 'protal', // 官网
  brm: 'brm' // brm业务日志
};

const EventType = {
  index: 'index', // 默认日志
  question: 'question', // 问题日志
  xhr: 'xhr', // 接口请求日志
  websocket: 'websocket' // websocket日志
};

class electronLogger {
  constructor(secretKey = '') {
    if (!secretKey || !SecretKey[secretKey]) {
      throw new Error('secretKey is required');
    }

    this.secretKey = secretKey;
  }

  log = (...args) => {
    this.baseLog('index', new Date(), ...args);
  };

  websocket = (...args) => {
    this.baseLog('websocket', new Date(), ...args);
  };

  xhr = (...args) => {
    this.baseLog('xhr', new Date(), ...args);
  };

  uploadLog = ({ date = new Date(), listen = false } = {}) => {
    electron.send('logger', {
      event: 'upload',
      data: {
        date: new Date(date),
        secretKey: this.secretKey,
        listen
      }
    });
  };

  baseLog = (type = 'index', date = new Date(), ...message) => {
    if (!type || !EventType[type]) {
      throw new Error('type is required');
    }

    if (isElectron) {
      const newMessage = [...message].map((value) => {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || value === null) {
          return value;
        } else if (typeof value === 'object') {
          try {
            JSON.stringify(value);
            return JSON.stringify(value);
          } catch (e) {
            return `[Object ${Object.prototype.toString.call(value)}]`;
          }
        } else {
          return String(value);
        }
      });
      electron.send('logger', {
        event: 'print',
        data: {
          date,
          secretKey: this.secretKey,
          message: newMessage,
          type
        }
      });
    } else {
      console.log(...message);
    }
  };
}
const $logger = new electronLogger(SecretKey.brm);
export default $logger;
